<template>
  <v-row>
    <v-col cols="12">
      <Filtro />
    </v-col>

    <v-col cols="12">
      <Table />
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "Administrador",

  components: {
    Table: () => import("../components/Table"),
    Filtro: () => import("./components/Filtro")
  }
};
</script>
